import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { Download, Trash2 } from 'react-feather'

// Imports custom
import {
    FileManagerList,
    TooltipInformation,
    // LinearLoading,
    CustomDropDown
} from 'common'

export const FilesTable = ({ useFetchInit, readOnlyMode }) => {
    
    const {
        //------------- Generales
        // location,
        // paramsURL,
        //------------- globalStates
        // globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        // Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    // ------------------------------------------------ globalStates
    // const { formOpeningMode } = globalStates 
    // ------------------------------------------------ Helpers
    // ------------------------------------------------ Formularios
    // ------------------------------------------------ FetchData
    const { fetchAllFiles } = FetchData
    const { dataFiles } = fetchAllFiles
    // ------------------------------------------------ Actions
    const { handleClickDeleteDocument } = Actions

    const columnConfig = [
        { 
            //FIELD PARA TOOLTIP
            headerName: "Info", 
            minWidth: 80,
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const {iddocumento, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico} = params.data
                return(
                    <TooltipInformation 
                        idregistro={iddocumento}
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: "document_originalname", headerName: "NOMBRE DEL ARCHIVO", minWidth: 250, filter: true },
        {
            headerName: "OPCIONES",minWidth: 600,
            cellRenderer: (params) => {

                const { iddocumento, document_path, estado } = params.data
                return (
                    <CustomDropDown color={(estado===1)?'inherit':'error'}>
                        <MenuItem
                            component="a"
                            href={document_path} 
                            target="_blank" 
                        >
                            <ListItemIcon> <Download color="black"/> </ListItemIcon>
                            <ListItemText primary="Descargar" />
                        </MenuItem>
                        <MenuItem
                            onClick={() => handleClickDeleteDocument(iddocumento)}
                            disabled={readOnlyMode}
                        >
                            <ListItemIcon> <Trash2 color="black"/> </ListItemIcon>
                            <ListItemText primary="Eliminar" />
                        </MenuItem>
                    </CustomDropDown>
                )
            }
        },
    ]

    
    return (
        //ESTRUCTURA PARA INCLUIR CAJA DE BUSQUEDA
        <FileManagerList
            rowConfig={dataFiles}
            columnConfig={columnConfig}
        />
    )
    
}